import { useEffect, useState } from 'react'

const DESKTOP_MEDIA_QUERY = '(min-width: 768px)'

export function useIsDesktop() {
  const [isDesktop, setIsDesktop] = useState(
    () => window.matchMedia(DESKTOP_MEDIA_QUERY).matches,
  )

  useEffect(() => {
    const mql = window.matchMedia(DESKTOP_MEDIA_QUERY)

    const handler = (event: MediaQueryListEvent) => setIsDesktop(event.matches)

    mql.addEventListener('change', handler)

    return () => mql.removeEventListener('change', handler)
  }, [])

  return isDesktop
}
